import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react"
import SKLand from "@skland/one-bridge"
import anime from "animejs"
import classNames from "classnames"
import { useLandscapeDisplayInfo } from "@hg/layouts"
import { useRoleLogout, useRoleMeta, useShowRoleSelect } from "@hg/one-account"
import { LoginChannelSelectRenderer } from "@hg/one-account"
import config from "../../../../../config/config.json"
import { CustomLoginModalProps } from "@/components/Layout"
import i18nCommonData from "@/locales/zh-CN.json"
import { auth } from "@/utils/auth"
import Reg from "@/utils/reg"
import { adapter } from "@/utils/sdk"

import Exit from "../../components/Exit"
import InputPassword from "../../components/InputPassword"
import InputSmsCode from "../../components/InputSmsCode"
import Logo from "../../components/Logo"
import RegistryButton from "../../components/RegistryButton"
import Toast from "../../components/Toast"
import { GlobalContext, ISubPageProps } from "../../context"
import { useGameBattleStore } from "../Game/data/battle"
import { useGameRestart, useGameStore } from "../Game/store"
import { loginYostar, getUserInfo, logout, sendSmsCode } from "@/services"
import styles from "./index.module.less"
import emitter from '../../components/Bus'
interface PageRegistryProps extends ISubPageProps, CustomLoginModalProps {}

const PageRegistry: React.FC<PageRegistryProps> = (props) => {
    const {
        className,
        style,
        visible,
        sendSMS,
        smsCountDown,
        loginByPassword,
        loginByCode: loginCode,
    } = props

    const {
        state: { user },
        dispatch,
    } = useContext(GlobalContext)
    const { inRotate, width, height } = useLandscapeDisplayInfo()

    const pageRef = useRef<HTMLDivElement>(null)

    const [channelSelected, setChannelSelected] = useState(false)
    const [cd, setCd] = React.useState(0);
    const [account, setAccount] = React.useState("")
    const [password, setPassword] = React.useState("")

    const [smsCode, setSmsCode] = React.useState("")
    const [loginByCode, setLoginByCode] = useState(true)


    const handleLoginSucceed = useCallback(() => {
        dispatch({
            type: "updateContext",
            payload: {
                showRegistry: false,
            },
        })
        setAccount('');
        setPassword('');
        setSmsCode('');
        // window?.gtag('event','complete_login')
    }, [dispatch])

    const handleSelectHgChannel = () => {
        setChannelSelected(true)
    }
    const checkEmail = (email: string) => {
        // 验证邮箱格式是否正确
        const reg =
            /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        return reg.test(email)
    }
    const fetchUserInfo = useCallback(async () => {
        try {
            const { code, data } = await getUserInfo()
            if (code === 0 && data) {
                dispatch({
                    type: "updateContext",
                    payload: {
                        user: {
                            ...data,
                        },
                    },
                })
            } else {
                dispatch({
                    type: "updateContext",
                    payload: {
                        user: null,
                    },
                })
            }
        } catch (error: any) {
            dispatch({
                type: "updateContext",
                payload: {
                    user: null,
                },
            })
        }
    }, [dispatch])



    const handleLogin = useCallback(async () => {
        const _account = account.trim()
        const _smsCode = smsCode.trim()

        if (!_account) {
            Toast.message({
              content: 'Email address cannot be null',
            });
            return;
          }
        if (!checkEmail(_account)) {
            Toast.message({ content: i18nCommonData["tips.errorPhone"] })
            return
        }

        if (!_smsCode) {
            Toast.message({ content: i18nCommonData["tips.noSmsCode"] })
            return
        }
        try {
            const { code, data, msg } = await loginYostar(_account, _smsCode)
            if (code == 0) {
                await fetchUserInfo()
                handleLoginSucceed()
                // window?.gtag('event','complete_login')
            } else {
                Toast.message({
                    content: msg || "",
                })
            }
        } catch (error: any) {
            Toast.message({
                content: error?.message,
            })
        }

        // const { result, data, msg } = res
        // if (result && data?.token) {
        //     handleLoginSucceed()
        //     window.setTimeout(() => {
        //         setChannelSelected(false)
        //     }, 500)
        // } else {
        //     Toast.message({
        //         content: msg,
        //     })
        // }
    }, [
        account,
        loginByCode,
        loginByPassword,
        handleLoginSucceed,
        password,
        smsCode,
        setChannelSelected,
    ])

    const handleLogout = useCallback(async () => {
        await logout()
        auth.clearToken()
        setAccount("")
        setPassword("")
        setSmsCode("")
        setChannelSelected(false)
        emitter.emit('yostarLogout')
        dispatch({
            type: "updateContext",
            payload: {
                showRegistry: false,
            },
        })

        window.setTimeout(() => {
            dispatch({
                type: "updateContext",
                payload: {
                    user: null,
                },
            })
        }, 500)
    }, [dispatch])

    const handleKeyUp = useCallback(
        (e: React.KeyboardEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement

            if (e.key === "Enter") {
                handleLogin()
                target.blur()
            }
        },
        [handleLogin]
    )

    const handleSendSmsCode = useCallback(async () => {
        if (cd > 0) {
          return;
        }
        const _account = account.trim();
        // if (!_account || !Reg.isPhone.test(_account)) {
        //     return
        // }
        if (!_account) {
          Toast.message({
            content: 'Email address cannot be null',
          });
          return;
        }
        if (!checkEmail(account)) {
          Toast.message({
            content: 'Invalid Email address format',
          });
          return;
        }
    
        setCd(60);
        const tid = setInterval(() => {
          setCd((val) => {
            const newVal = val - 1;
            if (val <= 0) {
              window.clearInterval(tid);
              return 0;
            }
    
            return newVal;
          });
        }, 1000);
        await sendSmsCode(_account);
      }, [cd, account]);

    const loginForm = useMemo(() => {
        if (!channelSelected) {
            return null
        }

        return (
            <InputSmsCode
                account={account}
                smsCode={smsCode}
                smsCountDown={cd}
                setSmsCode={setSmsCode}
                setAccount={setAccount}
                handleKeyUp={handleKeyUp}
                handleSendSmsCode={handleSendSmsCode}
            />
        )
    }, [
        channelSelected,
        loginByCode,
        account,
        password,
        handleKeyUp,
        smsCode,
        cd,
        handleSendSmsCode,
    ])

    const handleExit = useCallback(() => {
        if (!user && channelSelected) {
            setChannelSelected(false)
            setAccount("")
            setPassword("")
            setSmsCode("")
        } else {
            dispatch({
                type: "updateContext",
                payload: {
                    showRegistry: false,
                },
            })
        }
    }, [channelSelected, dispatch, user])

    useEffect(() => {
        document.body.style.overflow = visible ? "hidden" : ""

        anime({
            targets: pageRef.current,
            opacity: visible ? 1 : 0,
            duration: 500,
            easing: "cubicBezier(0.25, 0.1, 0.25, 1)",
            begin: () => {
                if (pageRef.current) {
                    pageRef.current.style.display = ""
                }
            },
            complete: () => {
                if (pageRef.current) {
                    pageRef.current.style.opacity = visible ? "1" : "0"
                    pageRef.current.style.display = visible ? "" : "none"
                    pageRef.current.style.pointerEvents = visible
                        ? "auto"
                        : "none"
                }
            },
        })
    }, [visible])

    const pageStyles = useMemo(() => {
        if (inRotate) {
            return {
                width: height,
                height: width,
                transformOrigin: "left top",
                transform: `rotate(-90deg) translate3d(-${height}px, 0, 0)`,
            }
        }

        return {
            width,
            height,
        }
    }, [height, inRotate, width])

    const gameRestart = useGameStore((state) => state.storeRestart)
    const battleRestart = useGameBattleStore((state) => state.restart)
    useEffect(() => {
        dispatch({
            type: "updateContext",
            payload: {
                currentSubPage: null,
            },
        })

        const tid = window.setTimeout(() => {
            gameRestart()
            battleRestart()
        }, 500)

        return () => {
            window.clearTimeout(tid)
        }
    }, [user?.uid])
    interface ChannelRenderOption {
        /**
         * @desc 渠道ID
         * @type {string}
         * @memberof ChannelRenderOption
         */
        channel: string
        /**
         * @desc 渠道显示名
         * @type {string}
         * @memberof ChannelRenderOption
         */
        displayName: string
        /**
         * @desc Icon 渲染
         * @memberof ChannelRenderOption
         */
        renderIcon: (props?: { className?: string }) => React.ReactNode
        /**
         * @desc 触发选择渠道
         * @memberof ChannelRenderOption
         */
        onSelect: () => void
        /**
         * @deprecated use `onSelect` instead.
         * @desc 调用登录回调
         * @memberof ChannelRenderOption
         */
        onLogin: () => void
    }
    useEffect(() => {
        loginThirdAuth()
    }, [])
    const loginThirdAuth = async () => {
        let urlSearchParams = new URLSearchParams(window.location.search)
        let errMsg = urlSearchParams.get("errMsg") ?? ""
        // sns登入授权回调
        if (errMsg) {
            Toast.message({
                content: errMsg,
            })
            window.history.replaceState(
                {},
                document.title,
                `${window.location.origin}${window.location.pathname}`
            )
        } else {
            await fetchUserInfo()
            handleLoginSucceed()
            window.history.replaceState(
                {},
                document.title,
                `${window.location.origin}${window.location.pathname}`
            )
        }
    }

    let channels = [
        {
            channel: "fb",
            displayName: "",
            renderIcon: () => {},
            onSelect: () => {
                let redirectUrl = `${config.mainHost}`
                location.href = `${redirectUrl}/api/account/third-login?channel=facebook&redirect=${redirectUrl}`
            },
            onLoginL: () => {},
        },
        {
            channel: "apple",
            displayName: "",
            renderIcon: () => {},
            onSelect: () => {
                let redirectUrl = `${config.mainHost}`
                location.href = `${redirectUrl}/api/account/third-login?channel=apple&redirect=${redirectUrl}`
            },
            onLoginL: () => {},
        },
        {
            channel: "yostar",
            displayName: "",
            renderIcon: () => {},
            onSelect: () => {},
            onLoginL: () => {},
        },
    ]

    let currentAccount = {
        displayName: "",
        onLogin: () => {},
    }

    return (
        <div
            ref={pageRef}
            className={classNames(
                styles.registry,
                inRotate && styles.rotate,
                className
            )}
            style={{
                ...pageStyles,
                ...style,
            }}
        >
            <Logo />
            <Exit className={styles.exit} onClick={handleExit} />
            <div className={styles.box}>
                {/* 左右两边装饰物 */}
                <div className={styles.leftDeco}></div>
                <div className={styles.rightDeco}></div>
                {/* title：探索者信息 */}
                <div className={styles.registryTitle}></div>
                {/* button区域 */}
                <BottomButton
                    channelSelected={channelSelected}
                    handleLogin={handleLogin}
                    handleLogout={handleLogout}
                />
                {/* 中间区域 */}
                <div
                    className={classNames(
                        styles.center,
                        currentAccount &&
                            !channelSelected &&
                            !user &&
                            styles.large
                    )}
                >
                    {/* 未登陆 */}
                    <div
                        className={classNames(
                            styles.unlogin,
                            user && styles.hide
                        )}
                    >
                        <div className={styles.loginContentWrapper}>
                            <div
                                className={classNames(
                                    styles.loginContent,
                                    channelSelected && styles.showLoginForm
                                )}
                            >
                                {/* 渠道选择 */}
                                <div
                                    className={classNames(
                                        styles.step,
                                        styles.channelSelect
                                    )}
                                >
                                    <>
                                        {!SKLand.getSystemInfo().isApp ? (
                                            <div
                                                className={classNames(
                                                    styles.channels,
                                                    currentAccount &&
                                                        !channelSelected &&
                                                        styles.quickLogin
                                                )}
                                            >
                                                {channels.map((item) => {
                                                    return (
                                                        <div
                                                            key={`${item.channel}-channel`}
                                                            className={classNames(
                                                                styles.channel,
                                                                styles[item.channel]
                                                            )}
                                                            onClick={
                                                                item.channel !==
                                                                "yostar"
                                                                    ? item.onSelect
                                                                    : handleSelectHgChannel
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    styles.icon
                                                                }
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        ) : null}
                                    </>
                                </div>
                                {/* 输入框 */}
                                <div
                                    className={classNames(
                                        styles.step,
                                        styles.form
                                    )}
                                >
                                    {loginForm}
                                </div>
                            </div>
                        </div>
                        {/* tip区域 */}
                        {/* <Tip /> */}
                    </div>
                    {/* 登陆后 */}
                    <DoctorInfo />
                </div>
            </div>
            )
        </div>
    )
}

const BottomButton: React.FC<{
    channelSelected: boolean
    handleLogin: () => Promise<void>
    handleLogout: () => Promise<void>
}> = ({ channelSelected, handleLogin, handleLogout }) => {
    const {
        state: { user },
    } = useContext(GlobalContext)

    return (
        <div className={styles.bottom}>
            <div
                className={classNames(
                    styles.darkPattern,
                    (channelSelected || user) && styles.hidden
                )}
            ></div>
            {channelSelected && !user && (
                <RegistryButton
                    className={styles.button}
                    type="login"
                    onClick={handleLogin}
                />
            )}
            {user && !SKLand.getSystemInfo().isApp && (
                <RegistryButton
                    className={styles.button}
                    type="logout"
                    onClick={handleLogout}
                />
            )}
        </div>
    )
}

const Tip: React.FC<{
    style?: React.CSSProperties
}> = ({ style }) => {
    return <div style={style} className={styles.tips}></div>
}

const DoctorInfo: React.FC = () => {
    const {
        state: { user },
    } = useContext(GlobalContext)

    const roleMeta = useRoleMeta()
    // 是否是b服
    const isBilibili = useMemo(() => {
        return roleMeta && roleMeta.channel !== "account"
    }, [roleMeta])

    const showRoleSelect = useShowRoleSelect()
    return (
        <div className={classNames(styles.doctorInfo, user && styles.show)}>
            <div className={styles.avatar}></div>
            <div
                className={styles.nickname}
                onClick={() => {
                    !isBilibili && showRoleSelect()
                }}
            >
                <div className={styles.label}>{`${user?.nickName}`}</div>
                {isBilibili ? null : <div className={styles.switch}></div>}
            </div>
        </div>
    )
}

export default PageRegistry
